import { errorHandler } from "./errorHandler";
import { CreateProductData } from "../interface";
import { apiRequest } from "./apiRequest";

export const postProduct = async (args: CreateProductData): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>("post", `/products`, {
      data: args,
    });

    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to create user");
  }
};
